import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Urban%20street%20style%20fashion%20photography%20with%20model%20wearing%20trendy%20outfit%20against%20colorful%20graffiti%20wall%2C%20golden%20hour%20warm%20sunlight%20casting%20long%20shadows%2C%20vibrant%20city%20atmosphere%2C%20editorial%20fashion%20composition%20with%20sneakers%20and%20accessories%20detail%2C%20modern%20youth%20culture%20aesthetic%2C%20dynamic%20energy%2C%20professional%20fashion%20shoot%20with%20shallow%20depth%20of%20field&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
        alt="Hipobuy Spreadsheet Product Research Guide"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/25 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs md:text-sm font-medium text-background-50">
            Updated 2026 Resources
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          Hipobuy Spreadsheet 2026
          <br />
          <span className="text-primary-300">The Ultimate Product Research Guide</span>
        </h1>

        <p className="text-sm md:text-base text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover the latest Hipobuy Spreadsheet resources, product categories, comparison guides and safety tips. Find better products faster with organized spreadsheet research across shoes, clothing, accessories and more.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Hipobuy Spreadsheet
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm md:text-base hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Visit Hipobuy Sheet
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 mt-8">
          {['Updated 2026 Resources', 'Beginner Friendly Guides', 'Detailed Comparison Tables', 'Safety Education'].map((badge) => (
            <div key={badge} className="flex items-center gap-1.5 text-xs text-background-200/80">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}